import React from "react";
import axios from "axios";

//Matrial-ui core
import { CircularProgress, Slide } from "@mui/material";
import { withStyles } from "tss-react/mui";

//Core items
import Button from "../../components/CustomButtons/Button";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import MainNavbar from "../../components/Navbars/MainNavbar";
import ApiLog from "./Modals/Detail/ApiLog";

//Tab items
import ArtikelTable from "./Modals/Detail/ArtikelTable";
import CustomFields from "./Modals/Detail/CustomFields";
import Notificaties from "./Modals/Detail/Notificaties";

import notificationsStyle from "../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";

//Globale functies
import { verifyEmail } from "../../utils";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import { toast } from "react-toastify";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class Detail extends React.Component {
  emailInput = React.createRef();
  mailButton = React.createRef();

  state = {
    saving: false,
    bestelling: {},
    loading: true,
    canSendEmail: false,
  };

  componentDidMount() {
    this.loadBestelling();
  }

  loadBestelling = () => {
    let bestellingId = this.props.match.params.id;

    axios.get("core/bestellingen/" + bestellingId).then((response) => {
      this.setState({ bestelling: response.data.data, loading: false });
    });
  };

  handleMailNotification = () => {
    let email = this.emailInput.current.value;

    axios.get(
      "/payment/paynl/sentinvoice/" + this.state.bestelling.id + "/" + this.state.bestelling.hash + "?mail=" + email,
      {
        baseURL: "",
      }
    );
  };

  verifyEmail = () => {
    let email = this.emailInput.current.value;

    if (verifyEmail(email)) {
      this.setState({ canSendEmail: true });
    }
  };

  render() {
    const { classes } = this.props;

    return !this.state.loading ? (
      <div>
        <MainNavbar
          paginaTitel={<TranslationWrapper tDefault={"Bestelling overzicht"} tKey={"bestellingen.pagetitle"} />}
        />
        <GridContainer>
          <GridItem md={4}>
            <TranslationWrapper tDefault={"Tafel"} tKey={"bestellingen.modal.detail.text.tafel"} />
          </GridItem>
          <GridItem md={8}>{this.state.bestelling.table ? this.state.bestelling.table.naam : ""}</GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem md={4}>
            <TranslationWrapper tDefault={"Sessie"} tKey={"bestellingen.modal.detail.text.sessie"} />
          </GridItem>
          <GridItem md={8}>{this.state.bestelling.sessionid}</GridItem>
        </GridContainer>
        <CustomFields customFields={this.state.bestelling.customFields} />
        <GridContainer>
          <GridItem md={4}>
            <TranslationWrapper tDefault={"Artikel(en)"} tKey={"bestellingen" + "." + "modal.detail.text.artikelen"} />
          </GridItem>
          <GridItem md={8}>
            <ArtikelTable
              items={this.state.bestelling.items}
              valuta={this.state.bestelling.vestiging !== null ? this.state.bestelling.vestiging.valuta : "EUR"}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem md={4}>
            <TranslationWrapper tDefault={"Bon Mailen"} tKey={"bestellingen.modal.detail.text.bonMailen"} />
          </GridItem>
          <GridItem md={4}>
            <input name={"bonmailen"} onChange={this.verifyEmail} ref={this.emailInput} type={"text"} />
          </GridItem>
          <GridItem md={4}>
            <Button
              color={"info"}
              disabled={!this.state.canSendEmail}
              onClick={this.handleMailNotification}
              ref={this.mailButton}
            >
              <TranslationWrapper tDefault={"verzend mail"} tKey={"bestellingen.modal.detail.text.sendmail"} />
            </Button>
          </GridItem>
        </GridContainer>
        <Notificaties bestelling={this.state.bestelling} />
        <ApiLog bestellingId={this.state.bestelling.id} {...this.props} />
      </div>
    ) : (
      <div style={{ margin: "25px auto" }}>
        <CircularProgress />
      </div>
    );
  }
}

export default withStyles(Detail, notificationsStyle);
